import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const timeSeriesMetric = z.array(
  z.object({ plainDate: z.string(), value: z.number() }),
);

export const getThresholdUpsellWidgetAnalytics = {
  name: "getThresholdUpsellWidgetAnalytics" as const,
  input: z.null(),
  output: z.object({
    ordersWithWidgetAdditionsOverTime: timeSeriesMetric,
    totalOrdersWithWidgetAdditions: z.number(),
    addedRevenueOverTime: timeSeriesMetric,
    totalAddedRevenue: z.number(),
    currency: createEnum(Currency),
    ordersByNumberOfProductsAdded: z.array(
      z.object({
        numberOfProductsAdded: z.number(),
        numberOfOrders: z.number(),
      }),
    ),
  }),
};
